<yo-adding-area-ligne-parametrage
  [selectedTypeFactureClient]="TypeFactureClientEnum.FACTURE_CLIENT_PRESTATION"
  (onNewLigneParametrage)="this.retrieveNewLigneParametrage($event)">
</yo-adding-area-ligne-parametrage>

<yo-ligne-parametrage-data-grid
  #grid
  class="grid-container"
  [lignes]="ligneParametrageList"
  (onFilter)="this.loadData($event)">
  <div data-position="left">
    <yo-button
      [theme]="ButtonThemeEnum.DEFAULT"
      label="CRÉER"
      tooltip="Créer un nouveau paramétrage"
      iconClass="fa fa-plus"
      (onClick)="expandAddArea()">
    </yo-button>
  </div>

  <div data-position="right" class="custom-button-container">
    <yo-button
      [theme]="ButtonThemeEnum.DEFAULT"
      tooltip="Modifier les lignes de paramétrage sélectionnées"
      iconClass="fa fa-edit"
      [disabled]="!isRowSelected()"
      (onClick)="openModificationPopup()">
    </yo-button>
    <yo-button
      [theme]="ButtonThemeEnum.DEFAULT"
      tooltip="Modifier les périodes de prix et frais fixe HT"
      iconClass="fa fa-calendar"
      [disabled]="!isRowSelected()"
      (onClick)="openPeriodePopup()">
    </yo-button>
    <yo-button
      [theme]="ButtonThemeEnum.SAVE"
      iconClass="fa fa-save"
      tooltip="Enregistrer les lignes de paramétrage"
      [disabled]="!gridChanges.hasChanges()"
      (onClick)="save()">
    </yo-button>
    <yo-button
      [theme]="ButtonThemeEnum.DELETE_INNER"
      iconClass="fa fa-trash"
      tooltip="Supprimer les lignes de paramétrage sélectionnées"
      [disabled]="!isRowSelected()"
      (onClick)="delete()">
    </yo-button>
  </div>
</yo-ligne-parametrage-data-grid>

<dx-popup
  title="Paramétrage des éléments à facturer"
  [visible]="isEditLinesPopupDisplayed"
  height="80vh"
  width="auto"
  [maxWidth]="'90vw'"
  minWidth="600"
  resizeEnabled="true"
  (onHiding)="closeEditLinesPopup()">
  <div class="full-size">
    <yo-ligne-parametrage-data-grid
      #gridPopup
      class="grid-container"
      [lignes]="ligneToAddList"
      (onFilter)="this.loadData($event)">
      <div data-position="right" class="custom-button-container">
        <yo-button
          [theme]="ButtonThemeEnum.DEFAULT"
          tooltip="Modifier les lignes de paramétrage sélectionnées"
          iconClass="fa fa-edit"
          [disabled]="!isPopupRowSelected()"
          (onClick)="openModificationPopup()">
        </yo-button>
        <yo-button
          [theme]="ButtonThemeEnum.DEFAULT"
          tooltip="Modifier les périodes de prix et frais fixe HT"
          iconClass="fa fa-calendar"
          [disabled]="!isPopupRowSelected()"
          (onClick)="openPeriodePopup()">
        </yo-button>
        <yo-button
          [theme]="ButtonThemeEnum.SAVE"
          iconClass="fa fa-save"
          tooltip="Enregistrer les lignes de paramétrage"
          [disabled]="!canAddValues()"
          (onClick)="saveEditedLines()">
        </yo-button>
        <yo-button
          [theme]="ButtonThemeEnum.DELETE_INNER"
          iconClass="fa fa-trash"
          tooltip="Supprimer les lignes de paramétrage sélectionnées"
          [disabled]="!isPopupRowSelected()"
          (onClick)="delete()">
        </yo-button>
      </div>
    </yo-ligne-parametrage-data-grid>
  </div>
</dx-popup>

<dx-popup
  title="Modification de masse"
  [visible]="isModificationPopupDisplayed"
  width="auto"
  height="auto"
  minWidth="600"
  (onHiding)="closeModificationPopup()">
  <div class="dialog-line">
    <div class="label">Élément facturable</div>
    <div class="value">
      <yo-lookup
        [data]="elementFacturableResource.value() ?? []"
        [selectedItem]="selectedElementFacturable"
        [displayValue]="getElementFacturableDisplayValue"
        autoSelect="false"
        (onValueChange)="updateElementFacturable($event)"
        placeholder="Sélectionner l'élément facturable ...">
      </yo-lookup>
    </div>
  </div>
  <div class="dialog-line">
    <div class="label">Taxe</div>
    <div class="value">
      <yo-lookup
        [data]="taxeResource.value() ?? []"
        [selectedItem]="selectedTaxe"
        [displayValue]="getTaxeDisplayValue"
        autoSelect="false"
        (onValueChange)="updateTaxe($event)"
        placeholder="Sélectionner la taxe ...">
      </yo-lookup>
    </div>
  </div>
  <hr>
  <div class="dialog-line">
    <div class="label">Frais fixe</div>
    <div class="value">
      <yo-lookup
        [data]="fraisFixeAuCouvert.value() ?? []"
        [selectedItem]="selectedFraisFixe"
        [displayValue]="getFraisFixeDisplayValue"
        autoSelect="false"
        (onValueChange)="updateFraisFixe($event)"
        placeholder="Sélectionner le frais fixe ...">
      </yo-lookup>
    </div>
  </div>
  <div class="dialog-line">
    <div class="label">Taxe FF</div>
    <div class="value">
      <yo-lookup
        [data]="taxeResource.value() ?? []"
        [selectedItem]="selectedTaxeFF"
        [displayValue]="getTaxeDisplayValue"
        autoSelect="false"
        (onValueChange)="updateTaxeFF($event)"
        placeholder="Sélectionner la taxe ...">
      </yo-lookup>
    </div>
  </div>
  <div class="dialog-line">
    <div class="custom-button-container-right">
      <yo-button
        [theme]="ButtonThemeEnum.SAVE"
        iconClass="fa fa-check"
        (onClick)="applyModifications()">
      </yo-button>
    </div>
  </div>
</dx-popup>

<dx-popup
  title="Périodes"
  [visible]="isPeriodePopupDisplayed"
  width="auto"
  height="auto"
  minWidth="500"
  (onHiding)="closePeriodePopup()">
  <dx-tab-panel>
    <dxi-item title="Prix de vente HT">
      <div class="dialog-line">
        <div class="label">A partir de</div>
        <div class="value">
          <yo-date-picker
            [value]="dateSelectedPrix"
            (onValueChange)="onChangeDatePrix($event)">
          </yo-date-picker>
        </div>
      </div>
      <div class="dialog-line">
        <div class="label">Prix de vente HT</div>
        <div class="value">
          <dx-number-box
            [(value)]="selectedPrix"
            placeholder="Prix de vente HT">
          </dx-number-box>
        </div>
      </div>
      <div class="dialog-line">
        <div class="label">Taux de revalorisation</div>
        <div class="value">
          <dx-number-box
            [(value)]="selectedTaux"
            placeholder="Taux en %">
          </dx-number-box>
        </div>
      </div>
      <div class="dialog-line">
        <div class="custom-button-container-right">
          <yo-button
            [theme]="ButtonThemeEnum.SAVE"
            iconClass="fa fa-check"
            (onClick)="applyPeriodePrix()">
          </yo-button>
        </div>
      </div>
    </dxi-item>
    <dxi-item title="Frais fixe HT">
      <div class="dialog-line">
        <div class="label">A partir de</div>
        <div class="value">
          <yo-date-picker
            [value]="dateSelectedFraisFixe"
            (onValueChange)="onChangeDateFraisFixe($event)">
          </yo-date-picker>
        </div>
      </div>
      <div class="dialog-line">
        <div class="label">Frais fixe HT</div>
        <div class="value">
          <dx-number-box
            [(value)]="selectedFraisFixeHT"
            placeholder="Frais fixe HT">
          </dx-number-box>
        </div>
      </div>
      <div class="dialog-line">
        <div class="label">Taux de revalorisation</div>
        <div class="value">
          <dx-number-box
            [(value)]="selectedTauxFraisFixeHT"
            placeholder="Taux en %">
          </dx-number-box>
        </div>
      </div>
      <div class="dialog-line">
        <div class="custom-button-container-right">
          <yo-button
            [theme]="ButtonThemeEnum.SAVE"
            iconClass="fa fa-check"
            (onClick)="applyPeriodeParametrageFacturationFraisFixe()">
          </yo-button>
        </div>
      </div>
    </dxi-item>
  </dx-tab-panel>
</dx-popup>
